export enum HttpMethod {
    get = 'GET',
    GET = 'GET',
    post = 'post',
    POST = 'POST',
    json = 'json',
    JSON = 'JSON',
}